import { SupportCasesItem } from '../../types';
import { callExternalApi, CallResult } from '../callExternalApi';

export interface FetchCaseQueryAttributes {
  key: string;
  value: string;
}

export interface Opts {
  query?: FetchCaseQueryAttributes;
  caseId?: string;
}

export async function fetchCases(accountIds?: string[], opts?: Opts): Promise<CallResult<SupportCasesItem[]>> {
  if (!accountIds?.length) return { data: null, error: { message: 'Must provide account ID to fetch cases' } };

  let url = 'api/cases';

  if (opts?.caseId) {
    url += `/${opts.caseId}`;
  }

  if (opts?.query) {
    const query = opts.query;
    url += `?${query.key}=${encodeURIComponent(query.value)}&account_ids=${accountIds.join(',')}`;
  } else {
    url += `?account_ids=${accountIds.join(',')}`;
  }

  return await callExternalApi<SupportCasesItem[]>({
    url: url,
    method: 'GET',
    headers: {
      'content-type': 'application/json'
    }
  });
}
